var _path, _path2, _circle, _circle2, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWazeLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 512 512",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m288 416c114.88 0 208-85.952 208-192s-93.12-192-208-192-208 85.952-208 192c0 0 15.008 96-64 96 0 80 144 96 272 96",
    fill: "#bbdefb"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m288 432c-193.792 0-288-36.64-288-112 0-8.832 7.168-16 16-16 15.872 0 27.456-4.544 35.424-13.824 18.688-21.856 12.832-63.296 12.768-63.712-.192-117.152 100.288-210.464 223.808-210.464 123.488 0 224 93.312 224 208s-100.512 208-224 208zm-253.568-97.664c15.232 43.04 102.144 65.664 253.568 65.664 105.888 0 192-78.976 192-176 0-97.056-86.112-176-192-176s-192 78.944-192 176c.192 0 8.16 53.792-20.256 86.976-10.592 12.352-24.416 20.192-41.312 23.36z",
    fill: "#455a64"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 352,
    cy: 432,
    fill: "#37474f",
    r: 64
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 160,
    cy: 432,
    fill: "#37474f",
    r: 64
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#455a64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m224.64 192c-8.832 0-16.16-7.168-16.16-16s7.008-16 15.84-16h.32c8.832 0 16 7.168 16 16s-7.168 16-16 16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m352.64 192c-8.8 0-16.16-7.168-16.16-16s7.008-16 15.84-16h.32c8.832 0 16 7.168 16 16s-7.168 16-16 16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m288 336c-46.144 0-85.472-31.424-95.616-76.48-1.92-8.64 3.488-17.184 12.096-19.136 8.64-1.856 17.184 3.456 19.136 12.096 6.816 30.336 33.312 51.52 64.384 51.52 31.104 0 57.568-21.184 64.384-51.52 1.984-8.608 10.432-14.016 19.136-12.096 8.64 1.952 14.048 10.496 12.128 19.136-10.144 45.024-49.472 76.48-95.648 76.48z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWazeLogo);
export default __webpack_public_path__ + "static/media/waze_logo.04a0af2d8db94a270dcf44c3dbab21e6.svg";
export { ForwardRef as ReactComponent };